import Filter from "./Filter";
import Sort from "./Sort";

export default function Sidebar() {
  return (
    <div className="sidebar-items">
      <Sort />
      <Filter />
    </div>
  );
}
